// 액션 타입 상수 정의
export const ActionTypes = {
  SET_DRIVES: 'SET_DRIVES', // 드라이브 목록 업데이트
  SET_SELECTED_DRIVE: 'SET_SELECTED_DRIVE', // 선택된 드라이브 업데이트
  SET_CURRENT_PATH: 'SET_CURRENT_PATH', // 현재 경로 업데이트
  SET_FOLDERS: 'SET_FOLDERS', // NavigationPane에서 사용하는 트리 데이터 업데이트
  SET_FOLDER_STRUCTURE: 'SET_FOLDER_STRUCTURE', // 전체 폴더 구조 폴더 구조 업데이트 (NavigationPane 사용)
  SET_ITEMS: 'SET_ITEMS', // 현재 경로의  (ListPane에 표시될 현재 경로의 모든 항목(파일+폴더)) 업데이트
  SET_SELECTED_KEYS: 'SET_SELECTED_KEYS', // 선택된 노드 키 업데이트
  SET_EXPANDED_KEYS: 'SET_EXPANDED_KEYS', // 확장된 노드 키 업데이트
  SET_LOADING: 'SET_LOADING', // 로딩 상태 업데이트
  SET_ERROR: 'SET_ERROR', // 오류 상태 업데이트
  SET_LOADED_KEYS: 'SET_LOADED_KEYS',
};

// 초기 상태 정의
export const initialState = {
  drives: [],
  selectedDrive: null,
  currentPath: '',
  folders: [],
  folderStructure: {},
  items: [],
  selectedKeys: [],
  expandedKeys: [],
  loadedKeys: [],
  loading: false,
  error: null,
};

// 리듀서 함수
export function fileExploreReducer(state, { type, payload }) {
  switch (type) {
    // * Drive
    case ActionTypes.SET_DRIVES:
      return { ...state, drives: payload };
    case ActionTypes.SET_SELECTED_DRIVE:
      return { ...state, selectedDrive: payload };

    // * Folder, Files
    case ActionTypes.SET_CURRENT_PATH:
      return { ...state, currentPath: payload };
    case ActionTypes.SET_FOLDERS:
      return { ...state, folders: payload };
    case ActionTypes.SET_FOLDER_STRUCTURE:
      if (typeof payload === 'function') {
        try {
          const newFolderStructure = payload(state.folderStructure);
          return { ...state, folderStructure: newFolderStructure };
        } catch (error) {
          return state;
        }
      }
      return { ...state, folderStructure: payload };
    case ActionTypes.SET_ITEMS:
      return { ...state, items: payload };
    // * key
    case ActionTypes.SET_SELECTED_KEYS:
      return { ...state, selectedKeys: payload };
    case ActionTypes.SET_EXPANDED_KEYS:
      if (typeof payload === 'function') {
        return { ...state, expandedKeys: payload(state.expandedKeys || []) };
      }
      return { ...state, expandedKeys: payload };
    case ActionTypes.SET_LOADED_KEYS:
      if (typeof payload === 'function') {
        return { ...state, loadedKeys: payload(state.loadedKeys || []) };
      }
      return { ...state, loadedKeys: payload };

    // * state

    case ActionTypes.SET_LOADING:
      return { ...state, loading: payload };
    case ActionTypes.SET_ERROR:
      return { ...state, error: payload };
    default:
      return state;
  }
}
